<template>
  <v-container :class="MobileSize ? 'mt-3' : ''">
    <v-dialog v-model="ModalPaymentQU" :style="MobileSize ? 'z-index: 16000004' : ''" persistent width="464">
      <v-card style="background: #FFFFFF; border-radius: 4px;">
        <v-toolbar flat color="#BDE7D9">
          <v-row>
            <v-col class="d-flex justify-space-around">
              <v-toolbar-title><span style="color: #27AB9C;" :class="MobileSize ? 'title-mobile' : ''"><b>วิธีการชำระเงิน</b></span></v-toolbar-title>
            </v-col>
          </v-row>
          <v-btn fab small @click="ModalPaymentQU = !ModalPaymentQU" icon><v-icon color="#27AB9C">mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-container>
          <v-card-text style="text-align: center;">
            <v-row dense justify="center">
              <v-col cols="12">
                <p style="font-weight: 600; font-size: 14px; line-height: 22px; color: #333333;">เลือกวิธีการชำระเงิน</p>
              </v-col>
              <v-col cols="12">
                <v-row dense justify="center">
                  <v-col cols="12" md="12" align="center" v-if="DetailQU.payment_method !== 'เครดิตเทอม'">
                    <v-card outlined width="124" height="148" style="border: 1px solid #D8EFE4; border-radius: 10px;" @click="openSelectTaxInvoice('ชำระเงินทันที')">
                      <v-card-text class="pt-8" style="cursor: pointer;">
                        <v-img src="@/assets/ImageINET-Marketplace/Shop/money.png" contain max-height="40" max-width="40"></v-img>
                        <p style="font-weight: 500; font-size: 10px; line-height: 14px; color: #333333;" class="pt-4">ชำระเงินทันที</p>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="12"  align="center" v-else>
                    <v-card outlined width="124" height="148" style="border: 1px solid #D8EFE4; border-radius: 10px;" @click="openSelectTaxInvoice('เครดิตเทอม')">
                      <v-card-text class="pt-8">
                        <v-img src="@/assets/ImageINET-Marketplace/Shop/term-loan.png" contain max-height="40" max-width="40"></v-img>
                        <p style="font-weight: 500; font-size: 10px; line-height: 14px; color: #333333;" class="pt-4">ใช้เครดิตเทอม</p>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="modalSelectTaxInvoice" persistent :style="MobileSize ? 'z-index: 16000004' : ''" width="464">
      <v-card style="background: #FFFFFF; border-radius: 4px;">
        <v-toolbar flat color="#BDE7D9">
          <v-row>
            <v-col class="d-flex justify-space-around">
              <v-toolbar-title><span style="color: #27AB9C;" :class="MobileSize ? 'title-mobile' : ''"><b>ขอใบกำกับภาษี</b></span></v-toolbar-title>
            </v-col>
          </v-row>
          <v-btn fab small @click="modalSelectTaxInvoice = !modalSelectTaxInvoice" icon><v-icon color="#27AB9C">mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-container>
          <v-card-text style="text-align: center;">
            <v-row dense justify="center">
              <v-col cols="12">
                <p style="font-weight: 600; font-size: 14px; line-height: 22px; color: #333333;">เลือกการขอใบกำกับภาษี</p>
              </v-col>
              <v-col cols="12">
                <v-row dense justify="center">
                  <v-col cols="12" md="12">
                    <v-row dense justify="center" class="ml-10 pt-0">
                      <v-col cols="12" align="center">
                        <v-radio-group v-model="taxRoles" row>
                          <v-radio color="#27AB9C" label="นิติบุคคล" value="Business"></v-radio>
                          <v-radio color="#27AB9C" label="ไม่รับใบกำกับภาษี" value="no"></v-radio>
                        </v-radio-group>
                      </v-col>
                      <v-col v-if="taxAddress === '' && taxRoles !== 'no'" cols="12" align="left" class="pt-2 pl-0">
                        <v-btn outlined icon small color="#A1A1A1" @click="openTaxAddress()"><v-icon color="#A1A1A1" small>mdi-plus</v-icon></v-btn>
                        <span class="pl-2"><b>เพิ่มที่อยู่ในการจัดส่งใบกำกับภาษี</b></span>
                      </v-col>
                      <v-col v-else-if="taxAddress !== '' && taxRoles !== 'no'" cols="12" align="left" class="pt-0 pl-0">
                        <p style="font-weight: bold;">ที่อยู่ในการจัดส่งใบกำกับภาษี :</p>
                        {{ companyName }}  {{ companyTaxID }} {{ taxAddress }}
                      </v-col>
                    </v-row>
                    <v-row justify="end">
                      <v-btn @click="GotoPayment()" color="#27AB9C" dark :disabled="taxAddress === '' && taxRoles !== 'no' ? true : false">ชำระเงิน</v-btn>
                    </v-row>
                    <!-- <v-card outlined width="124" height="148" style="border: 1px solid #D8EFE4; border-radius: 10px;" @click="GotoPayment()">
                      <v-card-text class="pt-8" style="cursor: pointer;">
                        <v-img src="@/assets/ImageINET-Marketplace/Shop/money.png" contain max-height="40" max-width="40"></v-img>
                        <p style="font-weight: 500; font-size: 10px; line-height: 14px; color: #333333;" class="pt-4">ชำระเงินทันที</p>
                      </v-card-text>
                    </v-card> -->
                  </v-col>
                  <!-- <v-col cols="12" md="6"  align="center">
                    <v-card outlined width="124" height="148" style="border: 1px solid #D8EFE4; border-radius: 10px;">
                      <v-card-text class="pt-8">
                        <v-img src="@/assets/ImageINET-Marketplace/Shop/term-loan.png" contain max-height="40" max-width="40"></v-img>
                        <p style="font-weight: 500; font-size: 10px; line-height: 14px; color: #333333;" class="pt-4">ใช้เครดิตเทอม</p>
                      </v-card-text>
                    </v-card>
                  </v-col> -->
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-container>
      </v-card>
    </v-dialog>
    <v-card width="100%" height="100%" elevation="0" :class="[ MobileSize ? 'mb-12 mt-4' : 'mb-4' ]">
      <v-card-title>
        <v-row dense>
          <v-col cols="12" md="6">
            <span style="font-weight: bold; font-size: 18px; line-height: 32px; color: #333333;"><v-icon color="#27AB9C" class="mr-2" @click="backtoListPoCompany()">mdi-chevron-left</v-icon>ใบเสนอราคา</span>
          </v-col>
          <v-col cols="12" md="6" align="end" v-if="DetailQU.status === 'edited'">
            <v-btn outlined color="#27AB9C" class="mr-4" @click="changeStatus('edit')"><v-icon color="#27AB9C" class="pr-2">mdi-pencil</v-icon> แก้ไข</v-btn>
            <v-btn outlined color="#F5222D" class="mr-4" @click="changeStatus('inactive')"><v-icon color="#F5222D" class="pr-2">mdi-delete-outline</v-icon> ยกเลิก</v-btn>
            <v-btn color="#27AB9C" dark @click="changeStatus('active')"><v-icon class="pr-2">mdi-check</v-icon> ยอมรับ</v-btn>
          </v-col>
          <v-col cols="12" md="6" align="end" v-else-if="DetailQU.status === 'waiting_approve'">
            <v-btn outlined color="#F5222D" @click="changeStatus('inactive')" class="mr-0"><v-icon color="#F5222D" class="pr-2">mdi-delete-outline</v-icon> ยกเลิก</v-btn>
          </v-col>
          <v-col cols="12" md="6" align="end" v-else-if="DetailQU.status === 'active'">
            <v-btn color="#27AB9C" class="mr-2 px-6" outlined dark @click="changeStatus('edit')" v-if="DetailQU.status_use_discount === 'yes'"><v-icon class="pr-2">mdi-ticket-percent-outline</v-icon> ใช้สิทธิพิเศษ</v-btn>
            <v-btn color="#27AB9C" class="mr-0 px-6" dark @click="ShowModalSelect()"><v-icon class="pr-2">mdi-cart</v-icon> สั่งซื้อ</v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" md="4">
            <span>วันที่สร้าง : <b>{{new Date(DetailQU.created_at).toLocaleDateString('th-TH', { year: 'numeric', month: 'numeric', day: 'numeric' })}}</b></span>
          </v-col>
          <v-col cols="12" md="4">
            <span>หมายเลขใบเสนอราคา : <b>{{  DetailQU.qu_number }}</b></span>
          </v-col>
          <v-col cols="12" md="4">
            <span>สถานะ : <b>{{  DetailQU.status === 'success' ? 'สร้างรายการสั่งซื้อแล้ว' : DetailQU.status === 'active' ? 'อนุมัติแล้ว' : DetailQU.status === 'waiting_approve' ? 'รออนุมัติ' : DetailQU.status === 'edited' ? 'ถูกแก้ไข' : DetailQU.status === 'reject' ? 'ปฏิเสธ' : 'ยกเลิก' }}</b></span>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" md="4">
            <span>วันที่อัปเดตล่าสุด : <b>{{new Date(DetailQU.updated_at).toLocaleDateString('th-TH', { year: 'numeric', month: 'numeric', day: 'numeric' })}}</b></span>
          </v-col>
          <v-col cols="12" md="4">
            <span>ส่งคำขอโดย : <b>{{ DetailQU.buyer_name }}</b></span>
          </v-col>
          <v-col cols="12" md="4" v-if="DetailQU.status === 'reject'">
            <span>เหตุผลในการปฏิเสธ : <b>{{ DetailQU.reason }}</b></span>
          </v-col>
        </v-row>
        <v-row dense>
          <!-- ใส่ iframe -->
          <v-card width="100%" height="100%" outlined style="background: #C4C4C4; border-radius: 8px;" class="mt-4">
            <v-card-text>
              <iframe :src="DetailQU.pdf_path_qu" width="100%" :height="MobileSize ? '500' : IpadSize ? '600' : '1200'"></iframe>
            </v-card-text>
          </v-card>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- dialog เลือกตำแหน่งก่อนชำระเงิน -->
    <v-dialog v-model="modalSetPositionCompany" width="732" :style="MobileSize ? 'z-index: 16000004' : ''" persistent>
      <v-card align="center" class="rounded-lg">
        <v-toolbar align="center" color="#BDE7D9" dark dense elevation="0">
          <span class="flex text-center ml-5" style="font-size:20px">
            <font color="#27AB9C">ข้อมูลตำแหน่งของบริษัท</font>
          </span>
          <v-btn icon dark @click="modalSetPositionCompany = !modalSetPositionCompany">
            <v-icon color="#27AB9C">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-title class="mt-4 my-3" style="font-size:14px; color: #333333; font-weight: 700;" v-if="MobileSize">รายชื่อตำแหน่งของบริษัทของฉัน ( {{ list_position.length }} รายชื่อ)</v-card-title>
        <v-card-title class="mt-9 my-3" style="font-size:20px; color: #333333; font-weight: 700;" v-else>รายชื่อตำแหน่งของบริษัทของฉัน ( {{ list_position.length }} รายชื่อ)</v-card-title>
        <v-card-text>
            <v-row dense no-gutters>
              <v-col cols="12" md="12" sm="12" xs="12" v-for="(item, index) in list_position" :key="index" class="mb-4">
                <v-card width="100%" height="100%" outlined
                  style="background: #FFFFFF; border: 1px solid #EBEBEB; border-radius: 8px;">
                  <v-card-text>
                    <v-row dense no-gutters>
                      <v-col cols="3" md="2" sm="2" class="pr-0">
                        <v-avatar size="60" style="background: #F2F2F2; border: 1px solid #E6E6E6; border-radius: 8px;"
                          rounded>
                          <v-img src="@/assets/ImageINET-Marketplace/Shop/office.png" contain width="36" height="36">
                          </v-img>
                        </v-avatar>
                      </v-col>
                      <v-col cols="9" md="7" sm="7" :class="MobileSize ? 'pt-4 pl-4' : 'pt-4 pl-0'">
                        <div
                          style="font-weight: 700; font-size: 18px; line-height: 26px; color: #333333; display: flex; align-items: center;">
                          {{ item.role_name }}</div>
                      </v-col>
                      <v-col cols="12" md="2" sm="2" class="pt-3 pl-6" :align="MobileSize ? 'end' : ''">
                        <v-btn text color="#27AB9C" @click="setPositionCompany(item)">เลือกตำแหน่ง<v-icon color="#27AB9C">
                            mdi-chevron-right</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <ModalTaxInvoice ref="ModalTaxAddress" :taxType="taxRoles" :frompage="QUPage" :ShippingType="QUPage"/>
  </v-container>
</template>

<script>
import { Encode, Decode } from '@/services'
export default {
  components: {
    ModalTaxInvoice: () => import('@/components/Cart/ModalAddress/TaxInvoiceAddress')
  },
  data () {
    return {
      QUID: '',
      ID: '',
      ShopID: '',
      DetailQU: [],
      ModalPaymentQU: false,
      modalSelectTaxInvoice: false,
      modalSetPositionCompany: false,
      dataToEdit: [],
      dataRole: '',
      taxRoles: 'no',
      taxAddress: '',
      companyName: '',
      companyTaxID: '',
      QUPage: 'QUPage',
      selectPayment: '',
      list_position: [],
      list_company: [],
      companyData: [],
      companyId: '',
      selectedCompany: '',
      com_perm_id: '',
      detailItemQu: ''
    }
  },
  created () {
    this.$EventBus.$emit('changeNavCompany')
    this.$EventBus.$emit('checkPathCompany')
    this.$EventBus.$on('checkAddressTaxinvoice', this.checkAddressTaxinvoice)
    if (localStorage.getItem('oneData') !== null && (localStorage.getItem('SetRowCompany') !== null || localStorage.getItem('CompanyData') !== null)) {
      this.companyData = JSON.parse(Decode.decode(localStorage.getItem('SetRowCompany')))
      this.companyId = this.companyData.company.company_id
      this.QUID = this.$route.query.QU_ID
      this.ID = this.$route.query.id
      this.ShopID = this.$route.query.shopID
      if (localStorage.getItem('detailItemQU') !== null) {
        this.detailItemQu = JSON.parse(Decode.decode(localStorage.getItem('detailItemQU')))
      }
      this.GetDetailQU()
      this.AuthorityUser()
    } else {
      this.$router.push({ path: '/' }).catch(() => {})
    }
  },
  watch: {
    MobileSize (val) {
      var itemsQU = JSON.parse(Decode.decode(localStorage.getItem('detailItemQU')))
      if (val === false) {
        this.$router.push({ path: `/QUCompanyDetail?QU_ID=${itemsQU.id}&id=${itemsQU.company_id}&shopID=${itemsQU.seller_shop_id}` }).catch(() => {})
      } else {
        this.$router.push({ path: `/QUCompanyDetailMobile?QU_ID=${itemsQU.id}&id=${itemsQU.company_id}&shopID=${itemsQU.seller_shop_id}` }).catch(() => {})
      }
    },
    taxRoles (val) {
      if (val === 'Business') {
        this.taxAddress = ''
      }
    }
  },
  computed: {
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadSize () {
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    },
    IpadProSize () {
      const { md } = this.$vuetify.breakpoint
      return !!md
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  methods: {
    getErrorMsg (msg) {
      if (msg === 'This user is unauthorized.') {
        return 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง'
      } else if (msg === 'The user was not found in the company.') {
        return 'คุณไม่ได้อยู่ในบริษัทใดเลย'
      } else if (msg === 'Company not found.') {
        return 'ไม่พบข้อมูลบริษัทในระบบ'
      } else if (msg === 'You are not in this Company.') {
        return 'คุณไม่ได้อยู่ในบริษัทนี้'
      } else if (msg === 'Data missing. Please check your [" company_id "] and try again.') {
        return 'ข้อมูลขาดหาย โปรดเช็ค [ รหัสบริษัท ] แล้วลองใหม่อีกครั้ง'
      } else if (msg === 'Order not found.') {
        return 'ไม่พบข้อมูลออเดอร์'
      } else if (msg === 'Data missing. Please check your [" order_number "] and try again.') {
        return 'ข้อมูลขาดหาย โปรดเช็ค [ เลขออเดอร์ ] แล้วลองใหม่อีกครั้ง'
      } else if (msg === 'User Has PDF not found.') {
        return 'ไม่พบข้อมูลใบเสนอราคา'
      } else if (msg === 'Token not found.') {
        return 'ไม่พบข้อมูลโทเค่น'
      } else if (msg === 'You not Have Permission Purchaser.') {
        return 'คุณไม่มีสิทธิ์ผู้ซื้อองค์กร'
      } else if (msg === 'Approve Position Purchaser Not Found.') {
        return 'ไม่พบรูปแบบการอนุมัติ'
      } else if (msg === 'Approve Position Budget Less Than Order Net Price.') {
        return 'วงเงินของรูปแบบการอนุมัติน้อยกว่าเงินสุทธิออเดอร์'
      } else if (msg === 'Your Company is not Partner With This Shop.') {
        return 'บริษัทของคุณไม่ได้เป็นคู่ค้ากับร้านค้า'
      } else if (msg === 'Company Credit With This Seller Shop Less Than Order Net Price.') {
        return 'เงินขององค์กรน้อยกว่าเงินสุทธิของออเดอร์'
      } else if (msg === 'Not Have Approver In Approve Position.') {
        return 'ไม่พบผู้อนุมัติในลำดับอนุมัติ โปรดเพิ่มผู้อนุมัติก่อน'
      } else if (msg === 'Sum Approve Position Budget Less Than Order Net Price.') {
        return 'ผลรวมของวงเงินแต่ละลำดับน้อยกว่าเงินสุทธิของออเดอร์'
      } else if (msg === 'Wrong Approve Position Type.') {
        return 'ประเภทการอนุมัติผิด'
      } else if (msg === 'Some User not Have Permission to Approve Order.') {
        return 'มีผู้ใช้ในลำดับที่ไม่มีสิทธิ์การอนุมัติ กรุณาตรวจสอบรูปแบบการอนุมัติ'
      } else if (msg === '') {
        return ''
      } else {
        // return 'ระบบขัดข้อง กรุณาติดต่อเจ้าหน้าที่'
        return msg
      }
    },
    async checkAddressTaxinvoice () {
      var onedata = JSON.parse(Decode.decode(localStorage.getItem('oneData')))
      // var dataRole = JSON.parse(localStorage.getItem('roleUser'))
      var dataCompany = ''
      if (localStorage.getItem('SetRowCompany') !== null) {
        var companyDataSet = JSON.parse(Decode.decode(localStorage.getItem('SetRowCompany')))
        dataCompany = companyDataSet.company.company_id
      } else {
        dataCompany = ''
      }
      var data = {
        user_id: onedata.user.user_id,
        role: 'purchaser',
        company_id: dataCompany,
        tax_type: this.taxRoles
      }
      await this.$store.dispatch('actionsGetInvoice', data)
      this.taxinvoiceAddress = await this.$store.state.ModuleUser.stategetInvoice
      // console.log('taxinvoiceAddress', this.taxinvoiceAddress)
      if (this.taxinvoiceAddress.data.length !== 0) {
        this.companyName = this.taxinvoiceAddress.data[0].name
        this.companyTaxID = 'เลขประจำตัวผู้เสียภาษี :' + ' ' + this.taxinvoiceAddress.data[0].tax_id
        this.taxAddress = this.taxinvoiceAddress.data[0].address + ' ' + 'แขวง/ตำบล' + ' ' + this.taxinvoiceAddress.data[0].sub_district + ' ' + 'เขต/อำเภอ' + ' ' + this.taxinvoiceAddress.data[0].district + ' ' + 'จังหวัด' + ' ' + this.taxinvoiceAddress.data[0].province + ' ' + this.taxinvoiceAddress.data[0].postal_code
      }
      // this.CreateOrderSyncTaxaddress()
    },
    openTaxAddress () {
      this.$refs.ModalTaxAddress.open()
      // มีการยิง api get ข้อมูลใบกำกับภาษี
      // localStorage.setItem('AddressData', Encode.encode(this.propsAddress[0].address_data))
    },
    openSelectTaxInvoice (val) {
      this.selectPayment = val
      this.ModalPaymentQU = !this.ModalPaymentQU
      this.modalSetPositionCompany = !this.modalSetPositionCompany
    },
    async GotoPayment () {
      this.$store.commit('openLoader')
      this.modalSelectTaxInvoice = !this.modalSelectTaxInvoice
      this.dataRole = JSON.parse(localStorage.getItem('roleUser'))
      var data = {
        etax: this.taxRoles,
        role_user: this.dataRole.role,
        qu_id: this.QUID,
        com_perm_id: this.com_perm_id
      }
      // console.log(data)
      await this.$store.dispatch('actionsGetPayment', data)
      var response = await this.$store.state.ModuleAdminManage.stateGetPayment
      // console.log(response)
      if (response.result === 'SUCCESS') {
        this.$store.commit('closeLoader')
        if (response.data.payment_method !== 'เครดิตเทอม') {
          if (response.data.have_approve === 'no') {
            if (response.data.can_pay === 'yes') {
              await this.CreateOrder(response.data)
              this.$store.commit('openLoader')
            } else {
              if (this.MobileSize) {
                this.$router.push({ path: `/orderDetailCompanyMobile?orderNumber=${response.data.payment_transaction_number}` }).catch(() => { })
              } else {
                this.$router.push({ path: `/orderDetailCompany?orderNumber=${response.data.payment_transaction_number}` }).catch(() => { })
              }
            }
          } else {
            if (this.MobileSize) {
              this.$router.push({ path: '/listApproveOrderMobile' }).catch(() => { })
            } else {
              this.$router.push({ path: '/listApproveOrder' }).catch(() => { })
            }
          }
        } else {
          const data = {
            company_id: response.data.company_id
          }
          await this.$store.dispatch('actionsDetailCompany', data)
          var responseCompany = await this.$store.state.ModuleAdminManage.stateDetailCompany
          localStorage.setItem('CompanyData', Encode.encode(responseCompany.data))
          if (response.data.have_approve === 'no') {
            if (this.MobileSize) {
              this.$router.push({ path: '/companyListCreditOrderMobile' }).catch(() => { })
            } else {
              this.$router.push({ path: '/companyListCreditOrder' }).catch(() => { })
            }
          } else {
            if (this.MobileSize) {
              this.$router.push({ path: '/listApproveOrderMobile' }).catch(() => { })
            } else {
              this.$router.push({ path: '/listApproveOrder' }).catch(() => { })
            }
          }
        }
      } else {
        this.$store.commit('closeLoader')
        var msg = this.getErrorMsg(response.message)
        this.$swal.fire({
          icon: 'error',
          text: msg,
          showConfirmButton: false,
          timer: 1500
        })
        if (this.MobileSize) {
          this.$router.push({ path: '/QUCompanyMobile' }).catch(() => { })
        } else {
          this.$router.push({ path: '/QUCompany' }).catch(() => { })
        }
      }
    },
    async CreateOrder (val) {
      // console.log(val)
      // this.$store.commit('openLoader')
      // var dataRole = JSON.parse(localStorage.getItem('roleUser'))
      // var data = {
      //   role_user: dataRole.role
      // }
      // await this.$store.dispatch('ActionCreateOrder', data)
      // var res = await this.$store.state.ModuleCart.stateCreateOrder
      // if (res.message === 'Create Order success.') {
      this.$store.commit('closeLoader')
      var dataPayment = {
        payment_transaction_number: val.payment_transaction_number
      }
      await this.$store.dispatch('ActionGetPaymentPage', dataPayment)
      var resRedirect = this.$store.state.ModuleCart.stateGetPaymentPage
      localStorage.setItem('PaymentData', Encode.encode(resRedirect))
      this.$router.push('/RedirectPaymentPage')
      // } else {
      //   this.$store.commit('closeLoader')
      //   this.$swal.fire({
      //     icon: 'error',
      //     text: `${response.message}`,
      //     showConfirmButton: false,
      //     timer: 1500
      //   })
      // }
    },
    async GetDetailQU () {
      var data = {
        type: 'buyer',
        id: this.ID,
        qu_id: this.QUID
      }
      await this.$store.dispatch('actionsDetailQUBuyer', data)
      var response = await this.$store.state.ModuleAdminManage.stateDetailQUBuyer
      if (response.result === 'SUCCESS') {
        this.DetailQU = response.data
      } else {
        this.DetailQU = []
        this.$swal.fire({
          icon: 'error',
          text: 'ไม่มีใบเสนอราคานี้ในบริษัท',
          showConfirmButton: false,
          timer: 1500
        })
        this.$router.push({ path: '/QUCompany' }).catch(() => {})
      }
    },
    async changeStatus (val) {
      var data
      // console.log(val)
      if (val === 'active' || val === 'inactive') {
        data = {
          company_id: this.ID,
          qu_id: this.QUID,
          status: val
        }
        // console.log(data)
        await this.$store.dispatch('actionsUpdateStatusBuyer', data)
        var response = await this.$store.state.ModuleAdminManage.stateUpdateStatusBuyer
        if (response.result === 'SUCCESS') {
          this.$swal.fire({
            icon: 'success',
            text: 'อัปเดตสถานะใบเสนอราคาสำเร็จ',
            showConfirmButton: false,
            timer: 1500
          })
          this.$EventBus.$emit('ListDataTable')
          this.$router.push({ path: '/QUCompany' }).catch(() => {})
        } else {
          this.$swal.fire({
            icon: 'error',
            text: `${response.message}`,
            showConfirmButton: false,
            timer: 1500
          })
          this.$router.push({ path: '/QUCompany' }).catch(() => {})
        }
      } else {
        var dataEdit = {
          company_id: this.ID,
          qu_id: this.QUID,
          role_user: 'purchaser',
          seller_shop_id: this.ShopID,
          id: this.ID,
          total_discount: this.detailItemQu.total_discount ? this.detailItemQu.total_discount : '',
          coupon_id: this.detailItemQu.coupon_id ? this.detailItemQu.coupon_id : '',
          point: this.detailItemQu.point ? this.detailItemQu.point : ''
        }
        const pathBack = window.location.href.split('/')
        this.$store.state.ModuleAdminManage.stateURLQu = `/${pathBack[3]}`
        // console.log('URL', this.$store.state.ModuleAdminManage.stateURLQu)
        // console.log(dataEdit)
        await this.$store.dispatch('actionsEditQU', dataEdit)
        const { result = '', data = {} } = await this.$store.state.ModuleAdminManage.stateEditQU
        if (result === 'SUCCESS') {
          this.$store.state.ModuleAdminManage.QuotationformData = await data
          this.$router.push({ path: `/Quotation?role=purchaser&&qu_id=${this.QUID}` }).catch(() => {})
          // this.$router.push({ name: 'QuotationCompany', path: '/Quotation', query: { role: 'purchaser', qu_id: this.QUID } }).catch(() => {})
        } else {
          this.$swal.fire({
            icon: 'error',
            text: 'ไม่มีข้อมูลแก้ไขใบเสนอราคานี้',
            showConfirmButton: false,
            timer: 1500
          })
          this.$router.push({ path: '/QUCompany' }).catch(() => {})
        }
      }
    },
    backtoListPoCompany () {
      if (this.MobileSize) {
        this.$router.push({ path: '/QUCompanyMobile' }).catch(() => {})
      } else {
        this.$router.push({ path: '/QUCompany' }).catch(() => {})
      }
    },
    ShowModalSelect () {
      this.ModalPaymentQU = !this.ModalPaymentQU
    },
    async AuthorityUser () {
      this.list_position = []
      await this.$store.dispatch('actionsAuthorityUser')
      var response = await this.$store.state.ModuleUser.stateAuthorityUser
      this.list_company = response.data.list_company
      this.list_company.forEach(element => {
        if (element.company_id === this.companyId) {
          this.selectedCompany = element
          element.array_position.forEach(position => {
            if (position.purchaser === true) {
              this.list_position.push(position)
            }
          })
        }
      })
    },
    // เลือกตำแหน่งก่อนชำระเงิน
    setPositionCompany (positionData) {
      var KepData = {
        company: {
          compant_name_en: this.selectedCompany.compant_name_en,
          compant_name_th: this.selectedCompany.compant_name_th,
          company_id: this.selectedCompany.company_id
        },
        position: positionData
      }
      this.com_perm_id = positionData.com_perm_id
      localStorage.setItem('SetRowCompany', Encode.encode(KepData))
      this.selectCompanyName = 'ตำแหน่ง : ' + positionData.role_name + '   บริษัท : ' + this.selectedCompany.compant_name_th
      localStorage.setItem('selectCompanyName', this.selectCompanyName)
      this.modalSelectTaxInvoice = !this.modalSelectTaxInvoice
      this.modalSetPositionCompany = !this.modalSetPositionCompany
    }
  }
}
</script>

<style>

</style>
